import axios from "axios";
import { Token } from "../utils/localStorage.util";
import config from "../config.js";

const baseURL = (config.REACT_APP_HOST_API_PLANEJAMENTO_TRIBUTARIO || "http://localhost:5337").trim().replace(/\/+$/, "");
const api = axios.create({
  baseURL: `${baseURL}/api/v1`,
});

api.interceptors.request.use(
  (cfg) => {
    const token = Token.getToken();
    if (token) cfg.headers.Authorization = token;
    if (!cfg.headers["Content-Type"] && !(cfg.data instanceof FormData)) {
      cfg.headers["Content-Type"] = "application/json";
    }
    return cfg;
  },
  (err) => Promise.reject(err)
);

api.interceptors.response.use(
  (res) => res.data,
  (err) => Promise.reject(err)
);

/**
 * Lista associados com filtros e paginação.
 * @param {{ page, per_page, tipo, tipo_documento, status, search, sort_by, sort_order, responsavel_id }} params
 */
export function listarAssociados(params = {}) {
  return api.get("/associados", { params });
}

/**
 * Lista parceiros com filtros e paginação.
 * @param {{ page, per_page, tipo_documento, status, associado_id, responsavel_id, search, sort_by, sort_order }} params
 */
export function listarParceiros(params = {}) {
  return api.get("/parceiros", { params });
}

/**
 * Detalhes de um associado.
 */
export function getAssociado(id) {
  return api.get(`/associados/${id}`);
}

/**
 * Detalhes de um parceiro.
 */
export function getParceiro(id) {
  return api.get(`/parceiros/${id}`);
}

/**
 * Cria associado. Payload: tipo, tipo_documento, documento, razao_social, nome_fantasia?, email, telefone?, endereco?, data_expiracao, responsavel_comercial_id, ativo?, dados_cpf?, dados_cnpj?, socios?, dados_financeiros?
 */
export function criarAssociado(payload) {
  return api.post("/associados", payload);
}

/**
 * Cria parceiro. Payload: associado_id, tipo_documento, documento, razao_social, email, telefone?, endereco?, data_expiracao, responsavel_comercial_id?, ativo?, dados_cpf?, dados_financeiros?
 */
export function criarParceiro(payload) {
  return api.post("/parceiros", payload);
}

/**
 * Atualiza associado (campos opcionais; documento/tipo não alteráveis).
 */
export function atualizarAssociado(id, payload) {
  return api.put(`/associados/${id}`, payload);
}

/**
 * Atualiza parceiro.
 */
export function atualizarParceiro(id, payload) {
  return api.put(`/parceiros/${id}`, payload);
}

/**
 * Desativa associado (soft delete). Rejeita se houver parceiros ativos.
 */
export function desativarAssociado(id) {
  return api.delete(`/associados/${id}`);
}

/**
 * Desativa parceiro (soft delete). Rejeita se houver empresas vinculadas.
 */
export function desativarParceiro(id) {
  return api.delete(`/parceiros/${id}`);
}

/**
 * Reativa associado.
 */
export function ativarAssociado(id) {
  return api.patch(`/associados/${id}/ativar`);
}

/**
 * Estrutura hierárquica para dropdowns: associados com seus parceiros.
 */
export function getHierarquia() {
  return api.get("/associados-parceiros/hierarquia");
}

/**
 * Lista responsáveis comerciais. params: { status?: 'ativo'|'inativo'|'todos' }
 */
export function getResponsaveisComerciais(params = {}) {
  return api.get("/responsaveis-comerciais", { params });
}

/**
 * Valida documento (CPF/CNPJ) e verifica se já existe cadastro ativo.
 */
export function validarDocumento(documento) {
  const doc = String(documento).replace(/\D/g, "");
  return api.get(`/validar-documento/${doc}`);
}

/**
 * Upload de documento (contrato_social, cartao_cnpj). entidade: 'associado'|'parceiro', entidadeId: number.
 */
export function uploadDocumento(file, tipo, entidade, entidadeId) {
  const form = new FormData();
  form.append("file", file);
  form.append("tipo", tipo);
  form.append("entidade", entidade);
  form.append("entidade_id", entidadeId);
  return api.post("/upload/documento", form);
}
